
import  React,{Component} from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { getReports } from '../../../../../jsx/actions/reportAction';
import { getPaygClients, getPaygResumeInfo, getPaygDashboardInfo } from '../../../../../jsx/actions/clientAction';
import { getPayments } from '../../../../../jsx/actions/paymentAction';
import { fetchSubscriptions } from '../../../../../jsx/actions/subscriptionAction';
import { fetchIntegrationBoxes, getIntegration } from '../../../../../jsx/actions/settingsAction';

import Map from './paygUserMap_OpenStreetMap';
// import { LineChart, DoughnutChart, BarChart } from './PaygChart';
import { LineChartGeneral, BarChartGeneral } from './PaygChartGeneral';
import PaygPopupInfo from './paygPopupInfo';
import InputText from '../../commonModules/interface/form-input-inline';
import { isEmpty, size } from "lodash";
import { TableRow, TableCell, TableHead, TableBody, Grid, TextField, Box, CircularProgress, IconButton, AppBar, Tabs, Tab, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, TableSortLabel, Button, Typography } from '@material-ui/core';
import { removeUrlParams } from '../urlParams';
import CardPage from '../../commonModules/layouts/CardPage';
import { TableLayout } from './Stock/containers/Layout';
import { CloudDownloadRounded, FilterListRounded } from '@material-ui/icons';
import TableFooterPagination from '../../commonModules/interface/TableFooterPagination';
import AllPhotos from './AllPhotos';
import { Skeleton } from '@material-ui/lab';
import SearchDrawer from './FilterModule/SearchDrawer';
import { lightBlue, orange, red, teal } from '@material-ui/core/colors';

var regexp = require('node-regexp');

var Moment = require('moment'),
    $ = require('jquery');
function toClassState(data) {
  var val = "";
  switch(data){
    case "OK":
      val = "success";
      break;
    case "PaygBlocked":
      val = "danger";
      break;
    case "NoConnection":
      val = "warning";
      break;
    case "InitPAYG":
      val = "info";
      break;
    case 'Dispossess':
      val = "darkError";
      break;
    case 'Demo':
      val = "warning";
      break;
    case "FullyPaid":
      val = "success";
      break;
    case "PaymentLate":
      val = "warning";
      break;
    default:
       console.log('[ERROR], toClassState, no value ,',data);
  }
  return val;
}

export const COLORS = {
	darkError: 
		// color: theme.palette.getContrastText(red[200]),
		 red[200],
	
	error: 
		// color: theme.palette.getContrastText(red[100]),
		 red[100],
	
	danger: 
		// color: theme.palette.getContrastText(red[100]),
		 red[100],
	
	info: 
		// color: theme.palette.getContrastText(lightBlue[100]),
		 lightBlue[100],
	
	warning: 
		// color: theme.palette.getContrastText(orange[100]),
		 orange[100],
	
	success: 
		// color: theme.palette.getContrastText(teal[100]),
		 teal[100],
	
	// primary: {
	// 	// color: theme.palette.getContrastText(theme.palette.primary.light),
	// 	 theme.palette.primary.light,
	// },
}
const PROSPECT = 'prospect';

const ABOS = {
	"Cash": "Cash",
	"Day": "Paygo",
	"Kwh": "Kwh",
}

class PaygResumeInfoList extends Component {
       
	state = {
		headerMenu: "LIST",
		paygoUser: [],
		paygoUserAll: [],
		popupUserInfo: false,
		sorting:{
			idBox:"",
			clientName: "",
			timeCreation: "",
			nextStopR: "",
			alarme: "",
			amount: "",
			evaluation: "",
			lastConnexionR: "",
			lastPaiementR: "",
			status: "",
			active: "",
		},
		dataset: "",
		userID: "",
		paymentList: [],
		clientStatsList: [],
		aboRadio: "",
		fetching: true,
		// Box demandée par l'URL (?boxAssoId=) mais absente de la liste chargée.
		boxNotFound: "",
		currentPage: 0,
        rowsPerPage: 20,
		searchName: "",

		openFilter: false,
		filteredInBack: [],
		searchData: { 
			phone: "",
			systemStatus : [],
			timeStart: "", // firstDayOfYear,
			timeStop: "",
			actualCommercial: []
		}
	}
		
	clearSorting = (sortField) => {
		let sortValue = "desc";
		if (this.state.sorting[sortField] === "desc"){
			sortValue = "asc";
		}

		this.setState({
			...this.state,
			sorting:{
				idBox:"",
				clientName: "",
				timeCreation: "",
				nextPaiementR: "",
				alarme: "",
				amount: "",
				evaluation: "",
				lastConnexionR: "",
				lastPaiementR: "",
				status: "",
				[sortField]:  sortValue,
				active: sortField,
			}
		});
	}
	
	componentDidMount = async () => {
		// État de l'intégration et sélection Prospect chargés silencieusement : en
		// refus d'accès ou en erreur, la colonne reste masquée.
		if(!this.props.PROSPECT_INTEGRATION || !this.props.PROSPECT_INTEGRATION.loading){
			this.props.getIntegration(PROSPECT)
		}
		if(!this.props.PROSPECT_BOXES || !this.props.PROSPECT_BOXES.fetching){
			this.props.fetchIntegrationBoxes(PROSPECT)
		}
		if(!this.props.PAYMENT_STATE.fetching && !this.props.PAYMENT_STATE.fetched){
			this.props.getPayments()
		}
		if(isEmpty(this.props.SUBSCRIPTIONS)){
			this.props.fetchSubscriptions()
        }
		if(!this.props.STATE.paygClients.fetching && !this.props.STATE.paygClients.fetched){
			await this.props.getClients()
		}
		
		// let reqList = []
		// if(!this.props.STATE.paygClients.fetching &&!this.props.STATE.paygClients.fetched){
		// 	reqList.push(this.props.getClients())
		// }
		// if(!this.props.PAYMENT_STATE.fetching && !this.props.PAYMENT_STATE.fetched){
		// 	reqList.push(this.props.getPayments())
		// }
		// if(isEmpty(this.props.SUBSCRIPTIONS)){
        //     this.props.fetchSubscriptions()
        // }
		// if (!isEmpty(reqList)){
		// 	await Promise.all(reqList)
		// }
		this.setState({ 
			filteredInBack: Object.values(this.props.CLIENTS).map(client => client.resume && client.resume.boxAssoId),
			fetching : false 
		})
		this.openBoxFromUrl()
		Promise.all([
			this.formatClientList(),
			// this.getPaymentsList(),
			// this.getClientStatsList()
		])
	}

	// getPaymentsList = () => {
	// 	const { PAYMENTS } = this.props
	// 	let payment_info_list = Object.values(PAYMENTS).filter( payment =>  payment.methodPayment !== 'gift')
	// 	this.setState({
	// 		paymentList: payment_info_list
	// 	})
	// 	return payment_info_list
	// }
		
	// getClientPaymentsList = (list) => {
	// 	const { PAYMENTS } = this.props
	// 	let payment_info_list = list.filter(ID => PAYMENTS[ID].methodPayment !== 'gift')
	// 	// list.forEach( ID => {
	// 	// 	if(PAYMENTS[ID].methodPayment !== 'gift'){
	// 	// 		payment_info_list.push(PAYMENTS[ID])
	// 	// 	}
	// 	// })
		
	// 	return payment_info_list
	// }
	
	formatClientList = () => {
		var methodName = 'paygoUser class';
		const { CLIENTS, SUBSCRIPTIONS } = this.props
		// console.log('[INFO],  reception des données  des utilisateur de PAYGO ');
		var paygoUserTmp = [];
		var dataset = "Type Abonnement, Status, Box Id, Nom client, derniere connexion, dernier paiement, prochain arret, montant paye, montant restant a payer,dernier code,alarme, evaluation \n";
		try {
			Object.keys(CLIENTS).filter(ID => !isEmpty(CLIENTS[ID].resume) ).map( ID => {
				const client = CLIENTS[ID].resume
		
				let totalToPay = ( client.totalToPay > 0) ? client.totalToPay : 1
				let percentagePayed = (client.totalPayed/totalToPay) * 100;
				let typeAbo = (SUBSCRIPTIONS && SUBSCRIPTIONS[client.subscriptionID]) && ABOS[SUBSCRIPTIONS[client.subscriptionID].type] 
				// typeAbo = typeAbo === "Day" ? "Paygo" : typeAbo 
		
				paygoUserTmp.push({
					id: client.idBox,
					name: client.clientName,
					lastConnexion: Moment(client.lastConnexion).format('DD/MMM HH:mm'),
					lastPaiement: Moment(client.lastPayment).format('DD/MMM'),
					nextPaiement: Moment(client.nextStop).format('DD/MMM HH:mm'),
					lastConnexionR: client.lastConnexion,
					lastPaiementR: client.lastPayment,
					nextPaiementR: client.nextStop,
					status: client.systemStatus,
					nextCode: client.lastCode,
					classN: toClassState(client.systemStatus),
					remboursement: percentagePayed.toFixed(0)+' % '+ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(client.totalToPay),
					alarme: client.errorCode,
					evaluation: client.systemStatus === "FullyPaid" ? "":client.paymentDelay,
					amount: percentagePayed * client.totalToPay,
					userId: client.userID,
					typeAbo,
				});

				let dataV = typeAbo+ 
				','+client.systemStatus+
				','+client.idBox+
				','+client.clientName+
				','+client.lastConnexion+
				','+client.lastPayment+
				','+client.nextStop+
				','+client.totalPayed+
				','+client.totalToPay+
				','+client.lastCode+
				','+client.errorCode+
				','+client.paymentDelay+'\n';

				dataset += dataV;
		
			})        
		} catch (e) {
			console.log(e);
			console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
			return;
		}
		console.log('DEBUG => List',paygoUserTmp[0]);
		var paygoUserTmpReserve = paygoUserTmp.reverse()
		console.log('DEBUG => List',paygoUserTmpReserve[0]);

		this.setState({
			paygoUser: paygoUserTmpReserve, 
			paygoUserAll: paygoUserTmpReserve,
			dataset: "data:application/csv;charset=utf-8," + encodeURIComponent(dataset)
		});
	}

	// getHumanizedata(val){
	// 	//console.log(val);
	// 	var val = Moment.duration(Moment().diff(Moment(val))).humanize();
	// 	return val;
	// }
	orderByNumber = (list) => {
		const {sorting} = this.state;
		if (sorting[sorting.active] === "desc"){
			list.sort(function (a, b) {
				a = a[sorting.active];
				b = b[sorting.active];
				if (a > b) {
					return -1;
				}
				if (a < b) {
					return 1;
				}
				return 0;
			});
		} else {
			list.sort(function (a, b) {
				a = a[sorting.active];
				b = b[sorting.active];
				if (a < b) {
					return -1;
				}
				if (a > b) {
					return 1;
				}
				return 0;
			});
		}
		return list
	}
	
	orderByDate = (list) => {
		const {sorting} = this.state;
		if (sorting[sorting.active] === "desc"){
			list.sort((a, b) => {
				a = new Date(a[sorting.active] || 0);
				b = new Date(b[sorting.active] || 0);
				if (a < b){
					return 1;
				}
				if (a > b){
					return -1;
				}
				return 0;
			});
		} else {
			list.sort((a, b) => {
				a = new Date(a[sorting.active] || 0);
				b = new Date(b[sorting.active] || 0);
				if (a > b){
					return 1;
				}
				if (a < b){
					return -1;
				}
				return 0;
			});
		}
		return list
	}
	
	filterList = (aboRadio = this.state.aboRadio , searchName = this.state.searchName) => {
		const { CLIENTS, SUBSCRIPTIONS } = this.props;
		const { filteredInBack } = this.state;
		// console.log('====================================');
		// console.log({aboRadio, searchName});
		// console.log('====================================');

		// CHANGE TO USE FILTERED IN BACK LIST
		// let paygoUserAll = Object.values(CLIENTS).filter(client => !isEmpty(client.resume)).map(client => client.resume )
		// let newList = paygoUserAll.filter(client => filteredInBack.includes(client.boxAssoId))

		let newList = []
		filteredInBack.map(boxAsso => {
			if (CLIENTS[boxAsso] && CLIENTS[boxAsso].resume ){
				newList.push(CLIENTS[boxAsso].resume)
			}
		})
		//Pour avoir les données avec les nouveaux abonnements en premiers
		newList =newList.reverse()
		//console.log('filterList====================================');
		//console.log({newList});
		//console.log('filterList====================================');
		let re = regexp().must(searchName).ignoreCase().toRegExp()
		let list = ( aboRadio !== "" ) ? newList.filter( user => 
			(SUBSCRIPTIONS && SUBSCRIPTIONS[user.subscriptionID]) && ABOS[SUBSCRIPTIONS[user.subscriptionID].type ] === aboRadio) : newList
		let filteredUserList = list.filter(user => (re.test(user.clientName) || re.test(user.idBox) ) )

		if (this.state.sorting.active){
			let SORTDATE = [
				"lastPaiementR",
				"nextPaiementR",
				"lastConnexionR",
				"timeCreation",
			]
			if (SORTDATE.includes(this.state.sorting.active)){
				filteredUserList = this.orderByDate(filteredUserList)
			} else {
				filteredUserList = this.orderByNumber(filteredUserList)
				
			}
		}

		return filteredUserList
	}
		
	filterAbo = (e) => {
		this.setState({aboRadio: e.target.value, currentPage:0 }) 
		this.filterList(undefined, this.state.searchName)
	}
	filterUser = (e) => {		
		this.setState({ searchName: e.target.value, currentPage:0});
		this.filterList(this.state.aboRadio)
	}

	// Lien direct (?boxAssoId=) : ouvre la fiche par le mécanisme du clic sur une ligne.
	// Box introuvable dans la liste chargée (pagination, filtre, autre compte) : la liste s'affiche
	// normalement avec une bannière, la recherche n'est pré-remplie que si le lien porte le n° de box.
	openBoxFromUrl = () => {
		const params = new URLSearchParams(window.location.search)
		const boxAssoId = params.get("boxAssoId")
		if (!boxAssoId) {
			return
		}
		// Traité : on retire les paramètres pour que la fiche ne se rouvre pas au remontage.
		removeUrlParams(["boxAssoId", "boxNumber"])
		const { CLIENTS } = this.props
		if (CLIENTS && CLIENTS[boxAssoId] && CLIENTS[boxAssoId].resume) {
			this.userDescriptionHandler(boxAssoId)
		} else {
			this.setState({ boxNotFound: boxAssoId, searchName: params.get("boxNumber") || "" })
		}
	}
	userDescriptionHandler = (boxAssoId) => {
		let userID = this.getUserID(boxAssoId);
		console.log("[DEBUG], Get Info for : ",boxAssoId, " and ",userID);

		if (userID === "" || userID === null){
			this.setState({ popupUserInfo: true, boxAssoId: boxAssoId })
		} else {
			this.setState({ popupUserInfo: true, boxAssoId: boxAssoId, userID: userID })
		}
	}
	getUserID = (ID) => {
		const { CLIENTS } = this.props;
		let userID = "";
		let user = CLIENTS[ID] && CLIENTS[ID].resume
		if (user) {
			userID = user.userID
		}
		// this.state.paygoUser.forEach( item => {
		// 	if (item.id === ID) {
		// 		console.log('ID:',ID,', vs ',item);
		// 		userID = item.userId;
		// 	}
		// } )
		return userID;
	}
	getClientStatsList = () => {
		const { CLIENTS, PAYMENTS, SUBSCRIPTIONS } = this.props
		let clientStatsList = []
		// console.log('================getClientStatsList start====================');
		// console.log({CLIENTS, PAYMENTS});
		// console.log('====================================');
		Object.values(CLIENTS).map( client => {
			let userInfo = client.resume
			if( client.payments ){
				let userPaymentsID = client.payments.filter(ID => PAYMENTS[ID].methodPayment !== 'gift')
				// let userPaymentsID = this.getClientPaymentsList(client.payments)
				if(!isEmpty(userPaymentsID) && !isEmpty(userInfo) ) {
					clientStatsList.push({
						userInfo,
						nextPaymentAmount: userInfo.nextPaymentAmount,
						initialPayment: userInfo.initialPayment,
						periodicity: userInfo.periodicity,
						payments: userPaymentsID,
						abo : !isEmpty(SUBSCRIPTIONS) && SUBSCRIPTIONS[userInfo.subscriptionID]

					})					
				}
			}
		})
		this.setState({
			clientStatsList
		}) 
	}
	// Colonne « Synchronisé avec Prospect » : visible seulement si l'intégration est
	// activée et la sélection chargée sans erreur (la page Home est vue par des rôles
	// sans accès aux intégrations).
	showProspectColumn = () => {
		const { PROSPECT_BOXES, PROSPECT_INTEGRATION } = this.props
		return !!(PROSPECT_INTEGRATION && PROSPECT_INTEGRATION.enabled && !PROSPECT_INTEGRATION.error
			&& PROSPECT_BOXES && PROSPECT_BOXES.fetched && !PROSPECT_BOXES.forbidden && !PROSPECT_BOXES.error)
	}
	// Set de la sélection, recalculé seulement quand la liste change (jusqu'à ~20 000 box).
	prospectSelectedSet = () => {
		const selected = (this.props.PROSPECT_BOXES && this.props.PROSPECT_BOXES.selected) || []
		if (this._prospectSelectedList !== selected){
			this._prospectSelectedList = selected
			this._prospectSelectedSet = new Set(selected)
		}
		return this._prospectSelectedSet
	}
	renderProspectCell = (boxAssoId, selectedSet) => {
		const synced = (this.props.PROSPECT_BOXES && this.props.PROSPECT_BOXES.synced) || {}
		const syncedAt = synced[boxAssoId]
		const excluded = (this.props.PROSPECT_BOXES && this.props.PROSPECT_BOXES.excluded) || {}
		// Box cochée mais écartée à la dernière synchro : motif affiché tel quel (chaîne du backend).
		if (selectedSet.has(boxAssoId) && excluded[boxAssoId]){
			return (
				<Box>
					<Box>Exclue</Box>
					<Box fontSize="0.75rem" color="text.secondary">{excluded[boxAssoId]}</Box>
					{syncedAt && <Box fontSize="0.75rem" color="text.secondary">dernier envoi le {Moment(syncedAt).format('DD/MM/YYYY')}</Box>}
				</Box>
			)
		}
		if (selectedSet.has(boxAssoId)){
			return syncedAt ? (
				<Box>
					<Box>Oui</Box>
					<Box fontSize="0.75rem" color="text.secondary">{Moment(syncedAt).format('DD/MM/YYYY')}</Box>
				</Box>
			) : 'En attente'
		}
		return syncedAt ? (
			<Box>
				<Box>Non</Box>
				<Box fontSize="0.75rem" color="text.secondary">envoyée le {Moment(syncedAt).format('DD/MM/YYYY')}</Box>
			</Box>
		) : 'Non'
	}
	createUserList = () => {
		let { paygoUser, currentPage, rowsPerPage } = this.state
		const { CLASSES, CLIENTS, SUBSCRIPTIONS, STATE } = this.props;

		let list = this.filterList()
		const showProspect = this.showProspectColumn()
		const prospectSelected = showProspect ? this.prospectSelectedSet() : null
		if( !isEmpty(paygoUser) ){
			let fetchInfoFor = list.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).filter(client => !client.resume_info ).map(client => client.boxAssoId)
			
			if (!isEmpty(fetchInfoFor) && !STATE.paygClients.fetching){
				this.props.getPaygResumeInfo(fetchInfoFor)
			}
			
			return {
				list: list.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).map( box => {
					
					let totalToPay = ( box.totalToPay > 0) ? box.totalToPay : 1
					let percentagePayed = (box.totalPayed/totalToPay) * 100;
					let typeAbo = (SUBSCRIPTIONS && SUBSCRIPTIONS[box.subscriptionID]) && SUBSCRIPTIONS[box.subscriptionID].type 
					typeAbo = typeAbo === "Day" ? "Paygo" : typeAbo 
					// console.log('====================================');
					// console.log({CLASSES});
					// console.log('====================================');
					
					return (
					// return paygoUser.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).map( box => (
						<TableRow 
							style={{ backgroundColor: COLORS[toClassState(box.systemStatus)] }} 
							key={box.boxAssoId} 
							id={box.boxAssoId} 
							onClick={() => this.userDescriptionHandler(box.boxAssoId)} 
							// onClick={() => this.userDescriptionHandler(box.idBox)} 
							hover
						>
							<TableCell>{typeAbo}</TableCell>
							<TableCell>{box.clientName}</TableCell>
							<TableCell>{box.idBox}</TableCell>
							<TableCell>{box.timeCreation ? Moment(box.timeCreation).format('DD/MM/YYYY') : '—'}</TableCell>
							{showProspect && <TableCell>{this.renderProspectCell(box.boxAssoId, prospectSelected)}</TableCell>}
							<TableCell>{!box.resume_info ? <Skeleton /> : Moment(box.lastPayment).format('DD/MMM')}</TableCell>
							<TableCell>{!box.resume_info ? <Skeleton /> : Moment(box.nextStop).format('DD/MMM HH:mm')}</TableCell>
							<TableCell>{!box.resume_info ? <Skeleton /> : box.systemStatus}</TableCell>
							<TableCell>{!box.resume_info ? <Skeleton /> : percentagePayed.toFixed(0)+' % '+ new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format(box.totalToPay)}</TableCell>
							<TableCell>{!box.resume_info ? <Skeleton /> : box.errorCode}</TableCell>
							<TableCell>{!box.resume_info ? <Skeleton /> : box.systemStatus === "FullyPaid" ? "":box.paymentDelay}</TableCell>
							<TableCell>{!box.resume_info ? <Skeleton /> : Moment(box.lastConnexion).format('DD/MMM HH:mm')}</TableCell>
							<TableCell>{!box.resume_info ? <Skeleton /> : box.lastCode}</TableCell>
							{/*<TableCell>{this.getHumanizedata(box.nextPaiement)}</TableCell>*/}
						</TableRow>
					)
				}),
				size: size(list)
			}
		}
		return {list: [], size: 0}
	}
	handleChange = (e, newHeader) => {
        this.setState({ 
            headerMenu: newHeader, 
        })
	}
	onChangePage = (pageOfItems, currentPage, rowsPerPage) => {
        // update state with new page of items
        this.setState({ currentPage, rowsPerPage });
    }
	handleOpenFilter = () => {
		this.setState({ 
			openFilter: true, 
		})		
	}
	handleCloseAndFilter = ( boxAssoIdList, data ) => {

		console.log('====================================');
		console.log({ boxAssoIdList });
		console.log('====================================');
		// find userInfo
		// setState
		// filterList
		this.setState({ 
			openFilter : false,
			filteredInBack: boxAssoIdList,
			searchData: data,
		})
	}
	handleReset = () => {
		this.setState({ 
			filteredInBack: Object.values(this.props.CLIENTS).map(client => client.resume && client.resume.boxAssoId),
		})
	}
	render() {
		const { paygoUser, sortDSC } = this.state;
		const { PAYMENTS } = this.props;
		let users = this.state.headerMenu === "LIST" ? this.createUserList() : {list: [], size: 0}
		// console.log('[INFO], render function Main PAYG', this.state);
		// console.log('================= props INFO ===================');
		// console.log(this.state.clientStatsList);
		// console.log('====================================');
		return (		
			<CardPage 
				title="Liste des utilisateurs"
				subtitle="Etat des connexions utilisateurs"
				// action={
				// 	<a href={this.state.dataset} download="MyJouleBox-User-Data.csv">
				// 		<IconButton color="secondary" title="Télécharger">
				// 			<CloudDownloadRounded />
				// 		</IconButton>
				// 	</a>
				// }
			>
				{this.state.fetching && <CircularProgress color="primary" /> }
				{!this.state.fetching &&
					<Box>
						{this.state.popupUserInfo && 
							<PaygPopupInfo 
								boxAssoId={this.state.boxAssoId}
								closePopup={() => this.setState({popupUserInfo: false})}
								USER_INFO_LIST = {["USER", "FAMILY", "OTHER", "PROSPECT"]}
								BOX_INFO_LIST = {["INSTALL", "BOX", "SYSTEM", "EQUIPEMENT","INFO3","INFO4","EQUIPEMENT_FROM_STORE_HOUSE","GEOLOCALISATION"]}
								PAYMENTS_INFO_LIST = {["RESUME", "LIST", "CHANGE_SUB","SPENT_LIST","COMMERCIAL"]} 
								SUIVI_INFO_LIST
								PHOTO
								home 
								default_tab = {"DASHBOARD"}
							/>
						}
						{this.state.boxNotFound &&
							<Box p={2}>
								<Typography variant="body2" color="error">
									{"Box " + this.state.boxNotFound + " introuvable dans la liste chargée"}
								</Typography>
							</Box>
						}
						<AppBar position="static">
							<Tabs
								value={this.state.headerMenu}
								onChange={this.handleChange}
								indicatorColor="secondary"
								// textColor="secondary"
								variant="fullWidth"
							>
								<Tab label="Statistiques" value="STATS" />
								<Tab label="Informations" value="LIST" />
								<Tab label="Localisation" value="MAP" />
							</Tabs>
						</AppBar>
						<Box p={2}>
							{ this.state.headerMenu === "LIST" &&
								<Box>
									<Grid container spacing={2}>
										{this.state.openFilter &&
											<SearchDrawer 
												phone
												status
												commercial
												activationDate
												search={this.state.searchData}
												handleClose={(data) => this.setState({ openFilter : false, searchData: data})}
												handleCloseSearch={this.handleCloseAndFilter}
												handleReset={this.handleReset}
											/>
										}
										<Grid item xs={12}>
											<Button 
												onClick={this.handleOpenFilter}
												startIcon={<FilterListRounded />}
												color="secondary"
												variant="contained"
											>
												Recherche Avancée
											</Button>
										</Grid>
										<Grid item xs={12}>
											<InputText
												onChange={this.filterUser}
												label="Rechercher"
												variant="outlined"
												style={{ width : "100%" }}
												value={this.state.searchName}
											/>
										</Grid>
				
										<Grid item sm={8} xs={12}>
											<Box p={2}>
												<FormControl component="fieldset">
													<FormLabel component="legend">Type d'abonnement</FormLabel>
													<RadioGroup 
														aria-label="aboRadio" 
														name="aboRadio" 
														value={this.state.aboRadio} 
														onChange={this.filterAbo}
														style={{ flexDirection: "row"}}
													>
														<FormControlLabel value="" control={<Radio />} label="Tous" />
														<FormControlLabel value="Cash" control={<Radio />} label="Cash" />
														<FormControlLabel value="Paygo" control={<Radio />} label="Paygo" />
														<FormControlLabel value="Kwh" control={<Radio />} label="Kwh" />
													</RadioGroup>
												</FormControl>
											</Box>
										</Grid>									
										<Grid item sm={4} xs={12}>
											<Box p={2}><h5>Nombre de Clients: {users.size}</h5> </Box>
										</Grid>
									</Grid>
				
									<TableLayout>
										<TableHead>
											<TableRow>
												<TableCell component="th">Type Abonnement</TableCell>
												<TableCell
													sortDirection={this.state.sorting.clientName}
													component="th" 
												>
													<TableSortLabel
														active={this.state.sorting.active === "clientName"}
														direction={this.state.sorting.clientName}
														onClick={()=> this.clearSorting("clientName")}
													>
														Nom Client
													</TableSortLabel>
												</TableCell>
												<TableCell component="th" sortDirection={this.state.sorting.idBox} >
													<TableSortLabel 
														onClick={()=> this.clearSorting("idBox")} 
														active={this.state.sorting.active === "idBox"}
														direction={this.state.sorting.idBox}
													>
														Paygo Id
													</TableSortLabel>
												</TableCell>
												<TableCell component="th" sortDirection={this.state.sorting.timeCreation} >
													<TableSortLabel
														onClick={()=> this.clearSorting("timeCreation")}
														active={this.state.sorting.active === "timeCreation"}
														direction={this.state.sorting.timeCreation}
													>
														Date d'enregistrement
													</TableSortLabel>
												</TableCell>
												{this.showProspectColumn() && <TableCell component="th">Synchronisé avec Prospect</TableCell>}
												<TableCell component="th">Dernier Paiement</TableCell>
												<TableCell component="th">Prochaine Coupure</TableCell>
												<TableCell component="th">Etat</TableCell>
												<TableCell component="th">Balance</TableCell>
												<TableCell component="th">Alarme</TableCell>
												<TableCell component="th">Evaluation</TableCell>
												<TableCell component="th">Dernière Connexion</TableCell>
												<TableCell component="th">Dernier Code</TableCell>

											</TableRow>
										</TableHead>
										<TableBody>
											{users.list}
										</TableBody>
										<TableFooterPagination
											colSpan={this.showProspectColumn() ? 13 : 12}
											count={users.size} 
											onChangePage={this.onChangePage} 
											initialPage={this.state.currentPage} 
										/>
									</TableLayout>
								</Box>            
							}
							{ this.state.headerMenu === "MAP" &&
								<Box>
									<Map />
								</Box>
							}
							{this.state.headerMenu === "STATS" &&
								<Box>
								{!isEmpty(PAYMENTS) ? (
									<div>
									{/* Periode : Par An, par mois */}
										{/* <LineChartGeneral 
											CLIENTS={this.state.clientStatsList} 
											general 
											paymentList={Object.values(PAYMENTS).filter( payment =>  payment.methodPayment !== 'gift')} 
											PAYMENTS={PAYMENTS} 
											title="Cumul des Paiements" legendPosition="right" 
										/>
										<BarChartGeneral 
											CLIENTS={this.state.clientStatsList} 
											general 
											paymentList={Object.values(PAYMENTS).filter( payment =>  payment.methodPayment !== 'gift')} 
											PAYMENTS={PAYMENTS} 
											title="Tendance Paiements " legendPosition="right" 
										/> */}
									</div>
							
								) : (
									<Box p={1} className="text-center">Pas assez d'informations pour le moment</Box>
								)}
								</Box>
							}
						</Box>
						
					</Box>
				}
			</CardPage>
		);
	}
}

function mapStateToProps(state){
    return {
        REPORTS: state.reports,
        CLIENTS: state.clients,
        STATE: state.inventory.requestState,
        PAYMENTS: state.payments,
        PAYMENT_STATE: state.inventory.requestState.payments,
        SUBSCRIPTIONS: state.subscriptions,
        PROSPECT_BOXES: state.settings && state.settings.boxes && state.settings.boxes[PROSPECT],
        PROSPECT_INTEGRATION: state.settings && state.settings.integrations && state.settings.integrations[PROSPECT],
    }
}

function mapDispatchToProps(dispatch){  
    return bindActionCreators({
        getReports,
        getClients: getPaygClients,
        getPayments,
		fetchSubscriptions,
		getPaygResumeInfo,
		getPaygDashboardInfo,
		fetchIntegrationBoxes,
		getIntegration,

    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(PaygResumeInfoList)